import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

const loginRequest = {
  scopes: ['User.Read', 'Sites.ReadWrite.All', 'Calendars.ReadWrite', 'Mail.ReadWrite', 'Mail.Read.Shared', 'Notes.ReadWrite'],
};

const graphRequest = {
  scopes: ['Sites.ReadWrite.All', 'Calendars.ReadWrite', 'Mail.ReadWrite', 'Mail.Read.Shared', 'Notes.ReadWrite'],
};

const msalInstance = new PublicClientApplication(msalConfig);

export { msalInstance, loginRequest, graphRequest };
